import { Rule } from "antd/lib/form"
import { i18n } from "~Shared/locales/i18n"

export const createCorporatesRules = () => ({
    required: [{ required: true, message: i18n.t("validation:required") }] as Array<Rule>,
    companyName: [
        { required: true, message: i18n.t("validation:required") },
        {
            validator: (_rule, value: string) => {
                if (value && value.length > 100) {
                    return Promise.reject(new Error(i18n.t("validation:below.string", { max: 100 })))
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    companyRegistrationNumber: [
        { required: true, message: i18n.t("validation:required") },
        {
            validator: (_rule, value: string) => {
                if (value && value.length > 20) {
                    return Promise.reject(new Error(i18n.t("validation:below.string", { max: 20 })))
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    countryCode: [
        { required: true, message: i18n.t("validation:required") },
        {
            validator: (_rule, value: string) => {
                if (value && value !== "") {
                    if (value.length !== 2) {
                        return Promise.reject(new Error(i18n.t("validation:exact.string", { num: 2 })))
                    }
                    if (!/[A-Z]{2}/.test(value)) {
                        return Promise.reject(new Error(i18n.t("validation:only_uppercase")))
                    }
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    city: [
        { required: true, message: i18n.t("validation:required") },
        {
            validator: (_rule, value: string) => {
                if (value && value !== "") {
                    if (value.length > 20) {
                        return Promise.reject(new Error(i18n.t("validation:max.string", { max: 20 })))
                    }
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    zip: [
        { required: true, message: i18n.t("validation:required") },
        {
            validator: (_rule, value: string) => {
                if (value && value !== "") {
                    if (value.length > 10) {
                        return Promise.reject(new Error(i18n.t("validation:max.string", { max: 10 })))
                    }
                    if (!/^[A-Za-z0-9 -]*$/.test(value)) {
                        return Promise.reject(new Error(i18n.t("validation:extended_alphanumeric")))
                    }
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    name: [
        { required: true, message: i18n.t("validation:required") },
        {
            validator: (_rule, value: string) => {
                if (value && value.length > 20) {
                    return Promise.reject(new Error(i18n.t("validation:below.string", { max: 20 })))
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
})
